const skills = {
  languages: [
    'Java', 'Python', 'C++', 'C', 'C#', 'JavaScript', 'TypeScript', 'R', 'Go', 'SQL', 'HTML/CSS',
  ],
  frameworks: [
    'React', 'Next.js', 'Flask', 'Django', 'Node.js', 'TensorFlow', 'PyTorch', 'LangChain',
  ],
  infrastructure: [
    'Docker', 'Kubernetes', 'Terraform', 'AWS', 'MongoDB', 'Firebase', 'PostgreSQL', 'Git', 'GitHub Actions',
  ],
};

export default skills;
